var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useEffect, useState, useId } from 'react';
import { isSmallTextFieldSizes, shouldDisplayPlaceholder } from '../../utils/input';
import { applyMargins, tvMerge } from '../../utils/tailwind';
import { ErrorMessage } from '../Form/ErrorMessage';
import { TYPOGRAPHY_VARIANTS } from '../Typography/styles';
import { DEFAULT_SIZE, DEFAULT_VARIANT } from './TextField.constants';
import { TextFieldLabel } from './TextFieldLabel';
import { affix, input, inputCentralizer, inputWrapper } from './styles';
const TextFieldComponent = (_a, ref) => {
    var { label, error, errorMessage, prefix, suffix, disabled, readonly, id, variant = DEFAULT_VARIANT, labelOption = 'default', size = DEFAULT_SIZE, className } = _a, props = __rest(_a, ["label", "error", "errorMessage", "prefix", "suffix", "disabled", "readonly", "id", "variant", "labelOption", "size", "className"]);
    const { m, ml, mr, mb, mt, mx, my } = props, inputProps = __rest(props, ["m", "ml", "mr", "mb", "mt", "mx", "my"]);
    const [isFocused, setIsFocused] = useState(false);
    const [isEmpty, setIsEmpty] = useState(true);
    const nonShrinkLabelOption = labelOption === 'nonshrink' || isSmallTextFieldSizes(size);
    const errorId = useId();
    useEffect(() => {
        props.value && setIsEmpty(true);
    }, [props.value]);
    return (_jsxs("div", { onFocus: () => !readonly && setIsFocused(true), onBlur: () => setIsFocused(false), className: tvMerge([applyMargins({ m, ml, mr, mb, mt, mx, my }), className]), children: [_jsxs("div", { className: inputWrapper({
                    size,
                    withStroke: variant === 'primary' || isFocused,
                    error,
                    isFocused,
                    disabled,
                    readonly,
                }), children: [prefix ? _jsx("div", { className: affix({ variant: 'prefix', size }), children: prefix }) : null, _jsxs("div", { className: inputCentralizer({
                            size,
                            center: nonShrinkLabelOption || !label,
                        }), children: [label ? (_jsx(TextFieldLabel, { disabled: disabled, hasValue: Boolean(!isEmpty || props.value || props.defaultValue || props.type === 'date'), hasError: error, htmlFor: id, isFocused: isFocused, label: label, labelOption: labelOption, size: size })) : null, _jsx("input", Object.assign({ id: id, "aria-invalid": !!error, "aria-describedby": error ? errorId : undefined, disabled: disabled, readOnly: readonly }, inputProps, { ref: ref, onChange: (event) => {
                                    var _a;
                                    event.target.value.length === 0 ? setIsEmpty(true) : setIsEmpty(false);
                                    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
                                }, className: input({
                                    placeholderVisible: shouldDisplayPlaceholder(labelOption, size, label),
                                    className: TYPOGRAPHY_VARIANTS.body,
                                }) }))] }), suffix ? _jsx("div", { className: affix({ variant: 'suffix', size }), children: suffix }) : null] }), _jsx(ErrorMessage, { error: error, errorMessage: errorMessage, id: errorId })] }));
};
export const TextField = forwardRef(TextFieldComponent);
